import React,{useEffect} from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const ProductDetailsSkeleton = () => {
  
   return (
    
          
          <div className="single-product-area section-padding-100 clearfix">
            <div className="container-fluid">
            <div className="row">
                    <div className="col-12 col-lg-7">
                        <div className="single_product_thumb">
                            <div id="product_details_slider" className="carousel slide" data-ride="carousel">
                            <ol className="carousel-indicators">
                            {Array(3).fill(0).map((img: any, index: any) => (
                                <Skeleton width={147} height={140}/>

                                    
                               
                                ))}
                                 </ol>
                                <div className="carousel-inner">
                                    <Skeleton width={604} height={604}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5">
                        <div className="single_product_desc">
                            {/* <!-- Product Meta Data --> */}
                            <div className="product-meta-data">
                                <div className="line"></div>
                                <p className="product-price"><Skeleton/></p>
                                <a href="product-details.html">
                                    <h6><Skeleton/></h6>
                                </a>
                                {/* <!-- Ratings & Review --> */}
                                <div className="ratings-review mb-15 d-flex align-items-center justify-content-between">
                                    <div className="ratings">
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                    </div>
                                    {/* <div className="review">
                                        <a href="#">Write A Review</a>
                                    </div> */}
                                </div>
                                {/* <!-- Avaiable --> */}
                                <p className="avaibility"><i className="fa fa-circle"></i><Skeleton/></p>
                            </div>

                            <div className="short_overview my-5">
                                <p><Skeleton/></p>
                            </div>

                            {/* <!-- Add to Cart Form --> */}
                            <form className="cart clearfix" method="post" >
                                <div className="cart-btn d-flex mb-50">
                                <Skeleton width={100} height={40}/>
                                </div>
                                <Skeleton width={310} height={80}/>
                            </form>

                        </div>
                    </div>


            </div>
        </div>
        </div>
  )
}

export default ProductDetailsSkeleton